{
    "UI_Container_Title": "Complete Account Setup",
    "UI_Container_Description": "Enter your full name and a password to complete registration",
    "UI_Name_Placeholder": "Full Name",
    "UI_Name_Label": "Full Name",
    "UI_Password_Placeholder": "Password",
    "UI_Password_Label": "Password",
    "UI_PasswordLengthValidation": "Password is too short",
    "UI_PasswordRequiredValidation": "Password must not be blank",
    "UI_PasswordStrengthValidation": "Password is not strong enough (make sure to include upper and lower case letters as well as numbers)",
    "UI_Footer_Server_Error": "Server Error",
    "UI_Footer_Submit_Button": "Submit",
    "UI_NameRequiredValidation": "Please enter your name",
    "NAME": "UserInvite"
}